import { STEPS } from '../fields';
import { PreviewFooter, PreviewTitle, PreviewBody } from '../preview-step';
import { RecordingFooter, RecordingTitle } from '../recording-step';
import { ConfigurationTitle, ConfigurationBody, ConfigurationFooter } from './configuration-step';
import { RecordingBody } from './recording-step';

export const WIZZARD = {
  [STEPS.CONFIGURATION]: {
    Title: ConfigurationTitle,
    Body: ConfigurationBody,
    Footer: ConfigurationFooter,
  },
  [STEPS.RECORDING]: {
    Title: RecordingTitle,
    Body: RecordingBody,
    Footer: RecordingFooter,
  },
  [STEPS.PREVIEW]: {
    Title: PreviewTitle,
    Body: PreviewBody,
    Footer: PreviewFooter,
  },
};
